module.exports = {};



//////////////////
// WEBPACK FOOTER
// /~/babel-runtime/~/core-js/library/modules/_iterators.js
// module id = 95
// module chunks = 31